import styled from "styled-components";

const StyledList = styled.li`
  border-bottom: 1px solid rgba(116, 223, 112, 0.9);
  width: 80%;
  resize: horizontal;
`;

export default StyledList;
